import React, { useContext } from "react"

const AppContext = React.createContext({
  currentUser: null,
})

export const useAppContext = () => {
  return useContext(AppContext)
}

export default AppContext
